<template>
    <app-ghost-mode>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 col-sm-6 col-12 offset-md-4 offset-sm-3 offset-0 my-5">
                    <div class="auth-box p-5">
                        <form>
                            <h3 class="text-center">aTrue Member <i class="fas fa-user-shield fa-sm text-dark-green"></i></h3>
                            <!-- Alert Messages -->
                            <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n2 mt-3 p-1`" role="alert">
                                <i class="fas fa-exclamation-circle"></i> {{ msg }}
                            </div>
                            <div class="mt-3">
                                <p class="text-center">
                                    To become aTrue Member, we need you to verify your email address. 
                                    Enter your valid email address, we will send you your verification link. 
                                    Open your mailbox and click the link to get verified.
                                </p>
                                <input v-model="newEmail" type="email" ref="email" class="form-control no-lines text-center" placeholder="your email">
                            </div>
                            <div class="text-center mt-4">
                                <button @click.prevent="sendLinkFxn" class="loadn btn btn-dark-green form-control">Send Verification Email</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "ValidateEmail",
    data() {
        return {
            msg: '',
            color: 'danger',
            newEmail: ''
        }
    },
    components: {
        appGhostMode: GhostMode
    },
    methods: {
        ...mapActions(['resendVerifyLink']),
        assignValues() {
            if(this.user.email){ this.newEmail = this.user.email }
        },
        sendLinkFxn() {
            this.color = 'danger'
            if(this.newEmail === ''){ this.msg = "Enter your email address"; return }
            let userObj = {
                userId: this.user._id,
                email: this.user.email,
                newEmail: this.newEmail
            }
            this.resendVerifyLink(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    this.newEmail = ''
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user']),
    },
    created() {
        this.assignValues()
    }
}
</script>